import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// --- Review Data ---
const REVIEWS = [
  {
    name: "Erika",
    text: "Elizabeta ist eine sehr herzliche Person, ein Sonnenschein. Sie arbeitet gründlich und sauber und geht auf die Wünsche des Kunden ein. Ergebnis war sehr gut. Ich freu mich auf meine nächsten Termine. Tolles Ambiente.",
    service: "Hydrating Facial",
  },
  {
    name: "Bezati",
    text: "Ich bin sehr zufrieden mit der Behandlungen! Elizabeta, das die Laserbehandlungen durchgeführt, ist äußerst professionell, aufmerksam und engagiert, verwendet moderne Techniken und sorgt dafür, dass man sich während der gesamten Behandlung wohlfühlt.",
    service: "Laser-Haarentfernung",
  },
  {
    name: "Ebru",
    text: "Ich habe mir nach dem ersten Mal das Paket gekauft, weil ich sehr zufrieden mit der Behandlung war. Ich finde Elizabeta sehr kompetent, sie weiß genau was sie tut und sie ist ein sehr herzlicher Mensch.",
    service: "Micro-Needling",
  },
  {
    name: "Özum",
    text: "Ich bin mit meiner Laserbehandlung sehr zufrieden. Das Ergebnis ist genau so, wie ich es mir gewünscht habe. Elizabeta war außerdem sehr freundlich und professionell.",
    service: "Laser-Haarentfernung",
  },
  {
    name: "Anxhela",
    text: "Elizabeta war super freundlich und hat mich während der ganzen Behandlung sehr wohl fühlen lassen. Ihre herzliche und professionelle Art macht die Behandlung wirklich angenehm.",
    service: "Laser-Haarentfernung",
  },
  {
    name: "Lara",
    text: "Sie war besonders aufmerksam und hat meine Haut beobachtet, da ich eine sensible Haut habe die ab und zu auch gerne mal auf ein Produkt reagiert. :)",
    service: "Hydrating Facial",
  },
  {
    name: "Alexandra",
    text: "Ich kann Elizabeta uneingeschränkt weiterempfehlen. Von der Aufklärung bis zur Behandlung war alles stets professionell. Eine klare Empfehlung meinerseits!",
    service: "Laser-Haarentfernung",
  },
];

// --- Styled Components ---

const ReviewSection = styled.section`
  padding: 120px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4efed;
  position: relative;
`;

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 60px;
  padding: 0 20px;
`;

const SmallTitle = styled(motion.span)`
  text-transform: uppercase;
  letter-spacing: 4px;
  font-size: 0.8rem;
  color: #a38d92;
  display: block;
  margin-bottom: 10px;
`;

const BigTitle = styled(motion.h2)`
  font-family: "The Seasons", serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: #1a1a1a;
  font-weight: 100;
  margin: 0;
`;

const MarqueeContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`;

const MarqueeTrack = styled(motion.div)`
  display: flex;
  gap: 30px;
  padding: 20px;
`;

const ReviewCard = styled.div`
  min-width: 450px;
  max-width: 500px;
  background: #e4dfd7;
  padding: 40px;
  border-radius: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex-shrink: 0;

  @media (max-width: 500px) {
    min-width: 250px;
    padding: 30px;
    max-width: 300px;
  }
`;

const Stars = styled.div`
  color: #d4af37;
  font-size: 1.2rem;
  letter-spacing: 2px;
`;

const ServiceTag = styled.span`
  font-family: "Georgia", serif;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #a38d92;
  background: rgba(255, 255, 255, 0.4);
  padding: 4px 12px;
  border-radius: 50px;
  align-self: flex-start;
`;

const ReviewText = styled.p`
  font-family: "Georgia", serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #4a3a3d;
  font-style: italic;
  margin: 10px 0;
`;

const ReviewerName = styled.span`
  font-family: "The Seasons", serif;
  font-weight: bold;
  font-size: 1.1rem;
  color: #1a1a1a;
`;
const CTA = styled.button`
  border: none;
  margin-top: 1em;
  background: #6d6357;
  padding: 12px 24px;
  color: white;
  font-size: 16px;
  font-family: "Poppins", cursive;
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    box-shadow: 0 0 14px 2px rgba(109, 99, 87, 0.3);
    transform: translateY(-2px);
  }
`;

// --- Component ---

const Reviews = () => {
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [trackWidth, setTrackWidth] = useState(0);

  // Duplicate reviews enough to create seamless loop
  const duplicatedReviews = [...REVIEWS, ...REVIEWS, ...REVIEWS];

  // Calculate widths on mount and resize
  useEffect(() => {
    const updateWidths = () => {
      if (trackRef.current && containerRef.current) {
        setTrackWidth(trackRef.current.scrollWidth / 3); // Divide by 3 since we have 3 sets
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidths();
    window.addEventListener("resize", updateWidths);
    return () => window.removeEventListener("resize", updateWidths);
  }, []);

  return (
    <ReviewSection>
      <TitleWrapper>
        <SmallTitle
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Love from my clients
        </SmallTitle>
        <BigTitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Kundenfeedback
        </BigTitle>
      </TitleWrapper>

      <MarqueeContainer ref={containerRef}>
        <MarqueeTrack
          ref={trackRef}
          animate={{
            x: [0, -trackWidth],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear",
            },
          }}
          drag="x"
          dragElastic={0.1}
          dragConstraints={{
            left: -trackWidth * 2, // Allow dragging into the duplicated content
            right: 0,
          }}
          onDragEnd={(event, info) => {
            // When dragging ends near the edge, animate back to a seamless position
            const threshold = trackWidth / 2;
            if (Math.abs(info.offset.x) > threshold) {
              // Reset position for seamless loop
              // This is a simplified version - you might want to implement
              // a more sophisticated reset logic based on your exact needs
            }
          }}
        >
          {duplicatedReviews.map((review, index) => (
            <ReviewCard key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Stars>★★★★★</Stars>
                <ServiceTag>{review.service}</ServiceTag>
              </div>
              <ReviewText>"{review.text}"</ReviewText>
              <ReviewerName>{review.name}</ReviewerName>
            </ReviewCard>
          ))}
        </MarqueeTrack>
      </MarqueeContainer>
      <Link
        to={"https://www.treatwell.de/ort/era-aesthetics-academy/"}
        target="_blank"
      >
        <CTA>Mehr anzeigen</CTA>
      </Link>
    </ReviewSection>
  );
};

export default Reviews;
